module.exports = __webpack_public_path__ + "img/shelter.a0c59d59.webp";